import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import _ from "lodash";
import { fetchDownloadPollsInfo_v2 } from "PollAction";
import { COMMON_FAIL_MESSAGE, converDateIntoLocal } from "Constants";
import LocaleStrings from "Languages";

class ExportPollsExcelBtn extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  downloadCSV = () => {
    let { session, selectedSession } = this.props;
    this.setState({ loading: true });
    this.props.fetchDownloadPollsInfo_v2(
      session,
      selectedSession,
      (response) => {
        if (response.success) {
          if (response.data.count !== 0) {
            _.forEach(response.data.pollinfo, (value, index) => {
              if (!_.isEmpty(value["Submitted on"])) {
                value["Submitted on"] = converDateIntoLocal(
                  value["Submitted on"]
                );
              }
            });

            let pollqa = {
              pollqa: response.data.pollinfo,
            };

            this.props.JSONToCSVConvertor(pollqa, true);
          } else {
            this.props.showError(LocaleStrings.no_data_found);
          }

          this.setState({ loading: false });
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
          this.setState({ loading: false });
        }
      }
    );
  };

  render() {
    return (
      <>
        <Button
          className="btn btn-custom-blue"
          onClick={this.downloadCSV}
          loading={this.state.loading}
        >
          <i className="fa fa-download i-custom-ms" aria-hidden="true" />
          {LocaleStrings.excel}
        </Button>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    selectedSession: state.selectedSession.resource,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  fetchDownloadPollsInfo_v2,
})(ExportPollsExcelBtn);
